import { useObservableValue } from '@/hooks/rx-hooks'
import { mediaQueryMatchStream } from '@/utils/browser-util'

// NOTE: This is mirrored in `css/media.css`
export const isSpacious$ = mediaQueryMatchStream(
  'screen and (min-width: 1100px) and (min-height: 485px)',
)

/**
 * Checks whether the spacious layout is in use.
 *
 * Media query is from `css/media.css`.
 */
export function useIsSpacious() {
  return useObservableValue(isSpacious$)
}
